import { UserProfileContext } from '@/contexts/UserProfileContext.js';
import { useContext } from 'react';

export const useUserProfile = () => {
  const userProfile = useContext(UserProfileContext);

  return userProfile;
};
